import styled from '@emotion/styled';
import { colors, Text } from '@innovationdepartment/proxima-ui';
import ButtonWithPopupWrapper from './ButtonWithPopupWrapper';
import InfoIcon from '../icons/Info';

const TooltipOrderedList = styled.ol`
  padding-left: 16px;
  color: ${colors.neutral100};

  & li {
    margin-bottom: 12px;

    &::marker {
      margin-right: 8px;
    }

    & strong {
      font-weight: 600;
    }
  }
`;

const TooltipContent = () => (
  <>
    <Text variant="body1" color="neutral80">
      <strong>Prompt Format Tips</strong>
    </Text>
    <TooltipOrderedList>
      <li>
        <Text variant="body3" color="neutral100">
          <strong>Define Your Objective:</strong> Clearly state what information you&rsquo;re
          seeking (e.g., sales figures, customer behavior).
        </Text>
      </li>
      <li>
        <Text variant="body3" color="neutral100">
          <strong>Specify Data Sources:</strong> Indicate which platforms or datasets to analyze
          (e.g., Shopify, ad platforms).
        </Text>
      </li>
      <li>
        <Text variant="body3" color="neutral100">
          <strong>Set Time Frames:</strong> Include specific periods for analysis (e.g., &ldquo;last
          7 days,&rdquo; &ldquo;Q1 2025&rdquo;).
        </Text>
      </li>
      <li>
        <Text variant="body3" color="neutral100">
          <strong>Clarify Output Format:</strong> Mention how you&rsquo;d like the data presented
          (e.g., summary, chart, table).
        </Text>
      </li>
    </TooltipOrderedList>
  </>
);

const FormatTooltip = () => (
  <ButtonWithPopupWrapper buttonText="Format Tips" buttonIcon={<InfoIcon />}>
    <TooltipContent />
  </ButtonWithPopupWrapper>
);

export default FormatTooltip;
